import { createSelector } from 'reselect';
import { Store } from '../../redux/reducers';
import { initialState } from './reducer';

const select = (state: Store) => state.bundles || initialState;

const makeSelectBundlesList = () =>
  createSelector(select, substate => substate.bundlesList);

const makeSelectAllBundlesList = () =>
  createSelector(select, substate => substate.allBundlesList);

const makeSelectLogs = () => createSelector(select, substate => substate.logs);

const makeSelectBundle = () =>
  createSelector(select, substate => substate.bundle);

const makeSelectCountList = () =>
  createSelector(select, substate => substate.count);

const makeSelectLoading = () =>
  createSelector(select, substate => substate.loading);

const makeSelectError = () =>
  createSelector(select, substate => substate.error);

export default select;
export {
  makeSelectBundlesList,
  makeSelectLogs,
  makeSelectBundle,
  makeSelectLoading,
  makeSelectCountList,
  makeSelectAllBundlesList,
  makeSelectError,
};
